/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement, HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLElement> {
  col: number;
  children?: ReactElement;
}

const Col = ({ children, col, ...rest }: Props): ReactElement => (
  <div className={`col-${col}`} {...rest}>
    {children}
  </div>
);

Col.defaultProps = {
  children: undefined,
};

export default Col;
